import { AxiosResponse } from 'axios';
import { axiosAuthInstance } from '../../instance.ts';
import {
  ICreateRecruiterProfileRequest,
  IRecruiterProfile,
  IUpdateRecruiterProfileRequest,
} from './types.ts';

const RecruiterAPI = {
  getMyProfile: (): Promise<AxiosResponse<IRecruiterProfile, void>> =>
    axiosAuthInstance.get('/profile/recruiter/me/'),

  createProfile: (
    payload: ICreateRecruiterProfileRequest,
  ): Promise<AxiosResponse<IRecruiterProfile, ICreateRecruiterProfileRequest>> =>
    axiosAuthInstance.post('/profile/recruiter/', payload),

  updateMyProfile: (
    payload: IUpdateRecruiterProfileRequest,
  ): Promise<AxiosResponse<IRecruiterProfile, IUpdateRecruiterProfileRequest>> =>
    axiosAuthInstance.patch('/profile/recruiter/', payload),
};

export default RecruiterAPI;
